import React from "react";
import { Link } from "react-router-dom";
import FormLayout, { MAROON, INK, EXP } from "../../pages/marketing/FormLayout";
import { useAuth } from "../../contexts/AuthContext";

// Shown to a signed-in user who does not (yet) have shop access. Enrollment
// creates a pending account; an admin approves it from the dashboard before the
// order form opens up.
export default function ShopAccessPending({ status }) {
  const { email, signOut } = useAuth();
  const declined = status === "declined";

  return (
    <FormLayout
      title={declined ? "Shop access unavailable" : "Awaiting approval"}
      subtitle="The Qentoros order form is available to approved veterinary practices."
    >
      <div
        className="q-reveal"
        style={{
          background: "#fff",
          border: "1px solid #E9E4DC",
          borderRadius: "18px",
          padding: "clamp(32px,5vw,56px)",
          textAlign: "center",
          boxShadow: "0 1px 2px rgba(26,25,23,.04)",
        }}
      >
        <div
          style={{
            width: "56px",
            height: "56px",
            borderRadius: "50%",
            background: MAROON,
            margin: "0 auto 22px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "27px",
            color: "#fff",
          }}
        >
          {declined ? "!" : "⏳"}
        </div>
        <h3
          style={{
            fontFamily: EXP,
            fontWeight: 700,
            fontSize: "25px",
            color: INK,
            marginBottom: "10px",
            letterSpacing: "-.01em",
          }}
        >
          {declined
            ? "Your shop access request wasn't approved."
            : "Your account is pending approval."}
        </h3>
        <p
          style={{
            fontSize: "16px",
            color: "#6E6A65",
            lineHeight: 1.55,
            maxWidth: "440px",
            margin: "0 auto 8px",
          }}
        >
          {declined
            ? "If you believe this is a mistake, please contact the Qentoros team and we'll be happy to help."
            : "A member of the Qentoros team is reviewing your enrollment. You'll be able to place orders here as soon as your practice is approved."}
        </p>
        {email && (
          <p style={{ fontSize: "13.5px", color: "#8A857F", marginTop: "6px" }}>
            Signed in as {email}
          </p>
        )}
        <div
          style={{
            marginTop: "26px",
            display: "flex",
            gap: "14px",
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          <Link
            to="/contact"
            style={{
              color: MAROON,
              fontWeight: 600,
              textDecoration: "none",
              fontSize: "15px",
            }}
          >
            Contact the team →
          </Link>
          <button
            type="button"
            onClick={() => signOut()}
            style={{
              background: "none",
              border: "none",
              color: "#8A857F",
              fontWeight: 600,
              fontSize: "15px",
              cursor: "pointer",
              fontFamily: "'Archivo',sans-serif",
            }}
          >
            Sign out
          </button>
        </div>
      </div>
    </FormLayout>
  );
}
